import { apiSalesWeb } from '@shared/config';

export interface IOnboardingInfoPayload {
  id: string;
  originUrl: string;
  visitorIp: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  requestPlans: IRequestPlan[];
  requestCustomers: IRequestCustomer[];
  requestPayments: IRequestPayment[];
}

export interface IRequestPlan {
  id: string;
  requestId: string;
  planDurationId: string;
  quantity: number;
  duration: number;
  externalId: string;
  unitAmount: number;
  totalAmount: number;
  paymentTypes: string[];
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export interface IRequestCustomer {
  id: string;
  requestId: string;
  documentType: string;
  documentNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export interface IRequestPayment {
  id: string;
  requestId: string;
  cardToken: string;
  firstSixNumbers: string;
  lastFourNumbers: string;
  brand: string;
  confirmationNumber: string;
  expirationDate: string;
  postalCode: string;
  addressNumber: string;
  complement: string;
  street: string;
  city: string;
  state: string;
  district: string;
  holderName: string;
  holderDocument: string;
  isSavedCard: boolean;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export async function getAllOnboardingInfo() {
  return apiSalesWeb.get<IOnboardingInfoPayload>('/request/onboarding-info');
}
